export const groupInviteCodes = content => [
  ...new Set(
    [
      ...String(content || '').matchAll(
        /(?:^|[\s(<"'])https:\/\/chat\.whatsapp\.com\/([A-Za-z0-9_-]{22})(?=$|[\s)>"'.,!?])/gi
      ),
    ].map(match => match[1])
  ),
];

export const groupInviteCodeFromUrl = href => {
  try {
    const url = new URL(href);
    if (
      url.origin !== 'https://chat.whatsapp.com' ||
      url.username ||
      url.password
    )
      return undefined;
    return url.pathname.match(/^\/([A-Za-z0-9_-]{22})$/)?.[1];
  } catch {
    return undefined;
  }
};
